import { render, staticRenderFns } from "./CommentSelectableDialog.vue?vue&type=template&id=17320786&scoped=true&"
import script from "./CommentSelectableDialog.vue?vue&type=script&lang=ts&"
export * from "./CommentSelectableDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CommentSelectableDialog.vue?vue&type=style&index=0&id=17320786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17320786",
  null
  
)

export default component.exports